import styled from 'styled-components';
import { media } from '../../../styles-and-themes/mediaUtils';

export const MiniFooterWrapV2 = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
  flex-grow: 1;
  display: flex;
  font-size: ${(p) => p.theme.fontSm};
  text-align: center;
  ul {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    list-style: none;
    padding-left: 0px;
    width: 100%;

    a {
      color: #0600B4;
    }
  }
  color: #0600B4;
  .footerLinks {
    flex: 2.5;
    font-size: 14px;
  }
  .miniLogo {
    flex: 1;
    margin-left: 30px;
    .footerLogo {
      height: 22px;
    }
  }
  ${media.between('xs', 'sm')`
    flex-direction: column;
    align-items: left;
    align-content: left;
    text-align: left;
    .footerLinks {
      flex: 1;
      display: block;
      ul {
        justify-content: flex-start;
      }
    }
    .miniLogo {
      flex: 1;
      display: block;
      margin-left: 0px;
      margin-top: 15px;
      width: 120px;
      height: 15px;
    }
    .divider {
      margin: 0 10px;
    }
  `}
  ${media.greaterThan('sm')`
    display: flex;
    align-items: flex-end;
    flex-direction: row;
  `}
`;

export const MiniFooterContentWrapV2 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
